<template>

  <div id="app">
    <div >
      <search-bar  ref="searchBarComponent" @searchBarHeight="getSearchBarHeight">

          <div slot="search-cont">

              <div class="item" >
                <div class="item-label">部门名称</div>
                <div style="width: 300px;" >
                  <el-input placeholder="请输入内容" v-model="search.name" class="input-with-select" size="small" @keyup.enter.native='getList'>
                  </el-input>
                </div>
              </div>

              <!--  操作按钮 start -->
                <div class="item">
                  <el-button class="item-btn" type="primary" @click="getList">查询</el-button>
                  <el-button class="item-btn reset-btn" @click="clearQuery">重置</el-button>
                </div>
              <!--  操作按钮 end -->

          </div>


      </search-bar>


      <div class="operation-tool">
        <div @click="handleEdit()" class="tool-item"> <img src="../../../static/img/btn/add.png" /> 添加部门</div>
      </div>


    <div class="l-panel">
          <div class="panel-body">
      <el-table class="l-table" stripe="" :data="dataList" style="width: 100%" @selection-change="handleSelectionChange" size="mini">

            <el-table-column prop="name" label="部门名称" align="left" width="200"> </el-table-column>
            <el-table-column prop="leader_name" label="部门负责人" align="left" > </el-table-column>
            <el-table-column prop="leader_mobile" label="负责人电话" align="right" width="200"> </el-table-column>
            <el-table-column prop="num" label="部门人数" align="right" > </el-table-column>
            <el-table-column prop="psort" label="排序" align="right" > </el-table-column>
            <el-table-column prop="statistics_display" label="是否在数据统计中" align="center" >
              <template slot-scope="{row}">

                <span  v-if="row.statistics_display==1" >是</span>
                <el-link :underline="false" type="danger" v-else>否</el-link>

              </template>
            </el-table-column>
            <el-table-column prop="statistics_total" label="是否在数据统计合计中" align="center" >
              <template slot-scope="{row}">
                <el-link :underline="false" v-if="row.statistics_total==1" type="primary">是</el-link>
                <span v-else>否</span>

              </template>
            </el-table-column>

            <el-table-column  label="操作" align="center" width="250px">
               <template slot-scope="{row}">

                 <el-button size="mini" @click="handleEdit(row.id)"><i class="el-icon-edit-outline"></i>修改</el-button>
                 <el-button type="primary" @click="searchDepartmentUser(row.id,row.name)" plain  size="mini" >查看部门成员</el-button>

               </template>
            </el-table-column>

          </el-table>
          <div class="c-table-pager">
                <el-pagination  @current-change="handleCurrentChange" :total="total" :page-size="20">
                </el-pagination>
          </div>
          </div>
    </div>


    </div>



  </div>

</template>

<script>
  import { WebUrl } from '@/api/index';
  import Message from '@/utils/message.js';
  export default{
    data:function(){
      return {
        search:{name:""},
        dataList:[],
        key:'',   //关键字搜索
        key_type:'', //关键字类型：
        page:1,   //页码
        total:1,

      }
    },
    activated() {
      this.getList()
    },
    created() {
          this.$nextTick(() => {
            document.onselectstart = new Function("event.returnValue=false");
          });
    },
    methods:{
      handleEdit(id){
        if(id){
          var ids=id
        }else{
          var ids = ''
        }
        this.$router.push({
          path:'/addEnterpriseDepartment?id='+ids
        })
      },
      searchDepartmentUser(id,name) {
        if(id) {
          this.$router.push({
            path:'/oasystemadminlist?departId='+id + '&departName='+name
          })
        }
      },
      clearQuery(){
        for(let key in this.search) {
          this.search[key] = ''
        }
        this.page = 1;
        this.getList()
      },
      // 获取操作栏展开收缩之后的高度
      getSearchBarHeight(val) {
          let sHeight = val;
          let fHeight = this.$refs.pageTableFilter ? this.$refs.pageTableFilter.clientHeight : 0;
          this.tableInitHeight = this.$util.setTableHeight(sHeight, fHeight);
      },
      //全部列表
      getList(){
        let param={
          page:this.page
        }
        for(let key in this.search) {
          param[key] = this.search[key]
        }
        this.gets('architecture/getDepartmentList',param)
        .then(res=>{
          this.dataList = res.data.data.list;
          this.total = res.data.data.pagination.total
          })
      },
        resumeTypeChange(){ this.selectId = []},

        changeDialogs(val){

        },
        //翻页
        handleCurrentChange(val){
        this.page = val
          this.getList()

        },
        selectChange(){this.$forceUpdate()},

       handleSelectionChange(val){
         let array = []
         array = val.map((item)=>{array.push(item.id);return array})
         this.selectId = array[array.length-1]

       },

    }
  }
</script>

<style scoped>
  .content{padding:20px 0px;box-sizing: border-box;width: 100%;}
  .pagination{margin:20px auto;width: 100%;text-align: center;}


</style>



// WEBPACK FOOTER //
// src/view/entrepriseArchitecture/enterpriseDepartment.vue